import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  pageContent: {
    height: "calc(100dvh - 124px)",
    overflowY: "auto",
    [theme.breakpoints.down("xs")]: {
      height: "calc(100dvh - 116px)"
    }
  },
  tabs: {
    width: "100%",
    boxShadow: "0 0 7px 0 rgba(0, 0, 0, 0.2)",
    "& > *": {
      width: "initial",
      maxWidth: "800px",
      margin: "0 auto"
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.secondary.dark
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      "& > *": {
        flex: "initial"
      }
    }
  },
  tab: {
    minHeight: theme.heightDesktopPageHeader,
    padding: "6px 12px 2px 12px",
    fontSize: "16px",
    fontFamily: "SuisseIntlMedium",
    color: theme.palette.secondary.dark
  }
}));
